import React from "react";
import "../CSS/main3.css";

function Main3() {
    return (
        <div className="main3">
            <div className="main3-heading">
                <h1>
                    Where should the QR code be placed?
                </h1>
            </div>
            <div className="main-content">

                <div className="container">
                    <div className="card">
                        <img
                            src={process.env.PUBLIC_URL + "/images/packing.jpg"}
                            alt="packing"
                        />

                        <h2>Packing</h2>
                        <p>
                            QR codes on packaging provide a quick and convenient way for consumers to access additional information about the product,
                            such as ingredients, usage instructions, promotional offers, and more. Here are some common applications of QR codes on packaging:
                        </p>
                    </div>
                    <div className="card">
                        <img src={process.env.PUBLIC_URL + "/images/art-01.jpg"}
                            alt="art" />
                        <h2>Creative & Other Uses</h2>
                        <p>Creative uses of QR codes span various industries and applications, leveraging their ability to store and share information
                            quickly and easily. Here are some innovative and creative ways QR codes are being utilized:
                        </p>
                    </div>
                    <div className="card">
                        <img src={process.env.PUBLIC_URL + "/images/print-media.png"}
                            alt="print-media" />
                        <h2>Print & Offline Media</h2>
                        <p>
                            QR codes in print and offline media serve as a bridge between physical materials and digital content, enhancing user engagement
                            and providing easy access to additional information. Here are some common applications of QR codes in print and offline media:
                        </p>
                    </div>
                    <div className="card">
                        <img src={process.env.PUBLIC_URL + "/images/public-outdoor.webp"} alt="public & outdoor" />
                        <h2>Public & Outdoor Uses</h2>
                        <p>
                            QR codes in public and outdoor settings are used to provide easy access to information, services, and interactive experiences for
                            people on the go. Here are some common applications of QR codes in public and outdoor environments:
                        </p>
                    </div>
                    <div className="card">
                        <img src={process.env.PUBLIC_URL + "/images/restaurants-hospitality.png"} alt="Restaurants & Hospitality" />
                        <h2>Restaurants & Hospitality</h2>
                        <p>
                            QR codes have become increasingly popular in the restaurants and hospitality industry, offering a convenient way for customers to
                            access menus, make reservations, and engage with services. Here are some common uses of QR codes in this sector:
                        </p>
                    </div>
                    <div className="card">
                        <img src={process.env.PUBLIC_URL + "/images/retail-physical-locations.png"} alt="Retail & Physical Location" />
                        <h2>Retail & Physical Locations</h2>
                        <p>
                            QR codes in retail and physical locations are used to enhance the shopping experience, provide product information, and
                            facilitate transactions. Here are some common applications of QR codes in retail settings:
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Main3;